
import { Vue, Component } from "vue-property-decorator";
import Intro from "@/components/feedback/participation/Intro.vue";
import Headline from "@/components/feedback/participation/Headline.vue";
import Examples from "@/components/feedback/participation/Examples.vue";
import ExampleCarrousel from "@/components/feedback/participation/ExampleCarrousel.vue";
import ExamplesSuite from "@/components/feedback/participation/ExamplesSuite.vue";
import Conclusion from "@/components/feedback/participation/Conclusion.vue";
import OneByOneComponentRenderer from "@/components/OneByOneComponentRenderer.vue";
import Results from "@/components/feedback/participation/Results.vue";
import { mapState } from "vuex";
import { FeedbackType } from "@/schemas/Enums";

@Component({
  components: {
    OneByOneComponentRenderer,
  },
  computed: {
    ...mapState("session", ["session"]),
  },
})
export default class ParticipationFeedback extends Vue {
  feedbackComponents = [Intro, Headline, Examples, ExamplesSuite, Results]; //, Conclusion
  feedbackComponentsAvg = [Intro, Results, Headline, ExampleCarrousel];

  // La fonction d'après sert a savoir si c'est le vieux FB ou le nouveau en moyenne, et atm on force que ce soit toujours en moyenne, pour tout le monde, même si la BDD dit le contraire
  get displayAvgFeedback(): boolean {
    // if (this.session.setting) {
    //   let settings = this.session.setting.feedback_details.find(
    //     (setting: {
    //       type: FeedbackType;
    //       display_feedback_message: boolean;
    //       display_score?: boolean;
    //       display_indiv_scores?: boolean;
    //       display_group_score?: boolean;
    //       display_avg_feedback?: boolean;
    //     }) => setting.type === FeedbackType.Performance
    //   );
    //   return settings ? settings.display_avg_feedback : false;
    // }
    // return false;
    return true;
  }
}
